"use client";

import { UserButton } from "@clerk/nextjs";
import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { LinkButton } from "./ui";
import { CurrencySelect, useCurrency } from "./currency-provider";

/** 侧栏现金钱包卡片：轮询 /api/me 显示真实 USD 余额与本地币估值。 */
export function CreditsBadge({
  showAccount = false,
  email,
}: {
  showAccount?: boolean;
  email?: string | null;
}) {
  const [balance, setBalance] = useState<number | null>(null);
  const { currency, formatUsdCents, exactUsdCents } = useCurrency();

  useEffect(() => {
    let alive = true;
    const load = () =>
      api
        .me()
        .then((m) => alive && setBalance(m.balanceCents))
        .catch(() => {});
    void load();
    const t = setInterval(load, 15_000);
    window.addEventListener("focus", load);
    return () => {
      alive = false;
      clearInterval(t);
      window.removeEventListener("focus", load);
    };
  }, []);

  return (
    <div className="card mt-6 p-4">
      {showAccount && (
        <div className="mb-3 flex items-center gap-2.5 border-b border-line pb-3">
          <UserButton />
          <span className="min-w-0 truncate text-[11px] text-muted">
            {email}
          </span>
        </div>
      )}
      <div className="flex items-baseline justify-between">
        <div className="text-[13px] font-medium">Cash balance</div>
        <div className="font-mono text-sm">
          {balance === null ? "…" : formatUsdCents(balance)}
        </div>
      </div>
      <div className="mt-1 text-[11px] text-muted">
        {balance !== null && currency !== "USD"
          ? `${exactUsdCents(balance)} wallet · estimated local value`
          : "Video generation is charged in USD"}
      </div>
      <CurrencySelect className="mt-3 w-full" />
      <LinkButton href="/studio/billing" size="sm" className="mt-3 w-full">
        Add funds
      </LinkButton>
    </div>
  );
}
